import { IonHeader, IonTitle, IonToolbar } from '@ionic/react';
import { useUserState } from '../../../hooks/context/useUserState';
import Logo from './Logo';
import MenuButton from './MenuButton';
import UserButton from './UserButton';
import GuideHeaderLauncher from '../../../components/Guide/GuideHeaderLauncher/GuideHeaderLauncher';
import { ReactNode } from 'react';
import { useVenueTitle } from '../../../hooks/useVenueTitle';

interface HeaderProps {
  onPopoverOpen?: () => void;
  onLogout: () => Promise<void>;
  filter?: ReactNode;
}

const Header = ({ onPopoverOpen, onLogout, filter }: HeaderProps) => {
  const {
    state: { username },
  } = useUserState();
  const { title: venueTitle, isLoading: venueTitleLoading } = useVenueTitle();

  const title = (
    <IonTitle className="branch-name">
      <h2 aria-live="polite" aria-busy={venueTitleLoading}>
        {venueTitle}
      </h2>
    </IonTitle>
  );

  return (
    <IonHeader>
      <IonToolbar style={{ overflow: 'visible' }}>
        <MenuButton />
        <Logo />
        <>
          {username && title}
          {filter}
          {username && <GuideHeaderLauncher />}
          {username && (
            <UserButton onPopoverOpen={onPopoverOpen} onLogout={onLogout} />
          )}
        </>
      </IonToolbar>
    </IonHeader>
  );
};

export default Header;
